import gql from "graphql-tag";

export const GET_BEST_TIME_SLICE_GEO = gql`
  query GET_BEST_TIME_SLICE_VALUES(
    $start: ZonedDateTime!
    $end: ZonedDateTime!
    $location: LocationInput!
  ) {
    waveHeight: bestTimeSliceValues(
      input: {
        start: $start
        end: $end
        dataSourceId: 19
        variableId: 20
        location: $location
      }
    ) {
      instant
      value
    }
    period: bestTimeSliceValues(
      input: {
        start: $start
        end: $end
        dataSourceId: 19
        variableId: 12
        location: $location
      }
    ) {
      instant
      value
    }
    peakDirection: bestTimeSliceValues(
      input: {
        start: $start
        end: $end
        dataSourceId: 19
        variableId: 32
        location: $location
      }
    ) {
      instant
      value
    }
    meanDirection: bestTimeSliceValues(
      input: {
        start: $start
        end: $end
        dataSourceId: 19
        variableId: 7
        location: $location
      }
    ) {
      instant
      value
    }
    spread: bestTimeSliceValues(
      input: {
        start: $start
        end: $end
        dataSourceId: 19
        variableId: 26
        location: $location
      }
    ) {
      instant
      value
    }
    windMagnitude: bestTimeSliceValues(
      input: {
        start: $start
        end: $end
        dataSourceId: 2
        variableId: 50
        location: $location
      }
    ) {
      instant
      value
    }
    windDirection: bestTimeSliceValues(
      input: {
        start: $start
        end: $end
        dataSourceId: 2
        variableId: 52
        location: $location
      }
    ) {
      instant
      value
    }
  }
`;
